export default __webpack_public_path__ + "static/media/pagekit.4c7ff750.svg";